export const EMOJI_CDN_BASE_URL = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64';
export const SHOPIFY_ADMIN_BASE_URL = 'https://admin.shopify.com/store';